var React = require('react');

function Icon (props) {
    return React.createElement("svg",props,[React.createElement("polygon",{"points":"17.5 21 17.5 1 1.65 11 17.5 21","style":{"fill":"none","stroke":"#eee","strokeWidth":"1","vectorEffect":"non-scaling-stroke"},"key":0}),React.createElement("rect",{"width":"18","height":"22","style":{"fill":"none"},"key":1})]);
}

Icon.defaultProps = {"viewBox":"0 0 18 22"};

module.exports = Icon;

Icon.default = Icon;
